<script>
import { mapState } from 'vuex';
import MineTitle from '../../components/mineTitle.vue';

export default {
    name: "supportDesk",
    data() {
        return {};
    },
    computed: {
        ...mapState(['userinfo']),
    },
    components: {
        MineTitle
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="supportDesk">
        <MineTitle :name="`Welcome back ${userinfo ? userinfo.name : ''} !`"/>
        <div class="wrapper">
            <div class="nums flex justify_between">
                <div class="item">
                    <p class="num">0</p>
                    <p class="text">Opened Tickets</p>
                </div>
                <div class="item">
                    <p class="num">0</p>
                    <p class="text">Answered Tickets</p>
                </div>
                <div class="item">
                    <p class="num">0</p>
                    <p class="text">Closed Tickets</p>
                </div>
            </div>
            <div class="list_group flex">
                <div class="list">
                    <div class="top flex justify_between align_center">
                        <div class="name flex align_center">
                            <img src="@/assets/images/icon_desk_01.png" alt="" class="icon"/>
                            <p>Last Opened Tickets</p>
                        </div>
                        <div class="btn flex_center">View all</div>
                    </div>
                    <div class="none flex_center">No data found</div>
                </div>
                <div class="list">
                    <div class="top flex justify_between align_center">
                        <div class="name flex align_center">
                            <img src="@/assets/images/icon_desk_02.png" alt="" class="icon"/>
                            <p>Last Answered Tickets</p>
                        </div>
                        <div class="btn flex_center">View all</div>
                    </div>
                    <div class="none flex_center">No data found</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    background: #fff;
    border-radius: .05rem;
    padding: .2rem;
}
.nums{
    padding: .4rem 0;
    margin-bottom: .2rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: .6rem;
    }
    .item{
        @media only screen and (max-width: 750px) {
            text-align: center;
        }
        .num{
            font-size: .48rem;
            margin-bottom: .2rem;
        }
        .text{
            font-size: .2rem;
            color: #999;
            @media only screen and (max-width: 750px) {
                font-size: .24rem;
            }
        }
    }
}
.list_group{
    gap: .2rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
    }
    .list{
        flex: 1;
        .none{
            font-size: .16rem;
            color: #999;
            height: 1.2rem;
            @media only screen and (max-width: 750px) {
                font-size: .2rem;
            }
        }
        .top{
            height: .5rem;
            background: #f5f5f5;
            padding: 0 .2rem;
            font-size: .16rem;
            color: #999;
            border-radius: .05rem;
            @media only screen and (max-width: 750px) {
                font-size: .2rem;
            }
            .icon{
                width: .26rem;
                margin-right: .1rem;
            }
            .btn{
                color: var(--background-color);
                border: 1px solid var(--background-color);
                height: .32rem;
                cursor: pointer;
                padding: 0 .1rem;
                border-radius: .3rem;
                &:hover{
                    background: var(--background-color);
                    color: #fff;
                }
            }
        }
    }
}
</style>